import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTitle } from './PageTitle';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-298" data-mp="2vcs6jgk9al09">
      <PageTitle data-id="element-299" data-mp="304a5y06msdj4" />
      <TopBar data-id="element-300" data-mp="304tqlono1g0u" />
      <Header data-id="element-301" data-mp="305bvf9oe92kd" />
      <main className="flex-1" data-id="element-302" data-mp="3053hdegjbr7l">
        <Outlet data-id="element-303" data-mp="3064tznd78lrf" />
      </main>
      <Footer data-id="element-304" data-mp="353wjkaqdfvsg" />
    </div>;
}